(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-email-bar-formatted"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-activity-email-message]').forEach(function(message) {
    window.setTimeout(function() {
      message.hidden = true;
      message.textContent = '';
    }, 5000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["betopper-collection-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-product-switcher')) {
    class CollectionProductSwitcher extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-category-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-collection-panel]'));
        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.setupCategoryTrack();
        this.panels.forEach((panel) => this.setupPanel(panel));
        this.activate(this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0], false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.categoryObserver) this.categoryObserver.disconnect();
        this.panels.forEach((panel) => panel._bcpObserver && panel._bcpObserver.disconnect());
      }

      setupCategoryTrack() {
        this.categoryTrack = this.querySelector('[data-category-track]');
        if (!this.categoryTrack) return;
        let frame = 0;
        const update = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.updateCategoryControls());
        };
        this.categoryTrack.addEventListener('scroll', update, { passive: true });
        if ('ResizeObserver' in window) {
          this.categoryObserver = new ResizeObserver(update);
          this.categoryObserver.observe(this.categoryTrack);
        }
        requestAnimationFrame(() => this.updateCategoryControls());
      }

      setupPanel(panel) {
        const track = panel.querySelector('[data-product-track]');
        if (!track) return;
        let frame = 0;
        const update = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.updateControls(panel));
        };
        track.addEventListener('scroll', update, { passive: true });
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(update);
          observer.observe(track);
          panel._bcpObserver = observer;
        }
      }

      handleClick(event) {
        const categoryArrow = event.target.closest('[data-category-direction]');
        if (categoryArrow && this.contains(categoryArrow) && this.categoryTrack) {
          const firstItem = this.categoryTrack.querySelector('[data-category-tab]');
          const styles = getComputedStyle(this.categoryTrack.querySelector('.bcp__categories'));
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = firstItem ? firstItem.getBoundingClientRect().width + gap : this.categoryTrack.clientWidth * 0.75;
          const direction = categoryArrow.dataset.categoryDirection === 'next' ? 1 : -1;
          this.categoryTrack.scrollBy({ left: direction * distance, behavior: 'auto' });
          return;
        }
        const tab = event.target.closest('[data-category-tab]');
        if (tab && this.contains(tab)) {
          this.activate(tab, true);
          return;
        }
        const arrow = event.target.closest('[data-direction]');
        if (!arrow || !this.contains(arrow)) return;
        const panel = arrow.closest('[data-collection-panel]');
        const track = panel && panel.querySelector('[data-product-track]');
        if (!track) return;
        const direction = arrow.dataset.direction === 'next' ? 1 : -1;
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'auto' });
      }

      handleKeydown(event) {
        const current = event.target.closest('[data-category-tab]');
        if (!current || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = this.tabs.indexOf(current);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.activate(this.tabs[nextIndex], true);
        this.tabs[nextIndex].focus();
      }

      handleBlockSelect(event) {
        const blockId = event.detail && event.detail.blockId;
        const tab = this.tabs.find((item) => item.dataset.blockId === blockId);
        if (tab) this.activate(tab, false);
      }

      activate(tab, scrollIntoView) {
        if (!tab) return;
        const blockId = tab.dataset.blockId;
        const currentTab = this.tabs.find((item) => item.classList.contains('is-active'));
        const shouldAnimate = Boolean(scrollIntoView && currentTab && currentTab !== tab);
        this.tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const active = panel.dataset.blockId === blockId;
          panel.classList.remove('is-entering');
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          if (active) {
            if (shouldAnimate) {
              void panel.offsetWidth;
              panel.classList.add('is-entering');
            }
            const track = panel.querySelector('[data-product-track]');
            if (track) track.scrollLeft = 0;
            requestAnimationFrame(() => this.updateControls(panel));
          }
        });
        if (scrollIntoView) tab.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      }

      updateControls(panel) {
        const track = panel.querySelector('[data-product-track]');
        const controls = panel.querySelector('[data-controls]');
        if (!track || !controls) return;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const progress = max > 0 ? (track.scrollLeft + track.clientWidth) / track.scrollWidth : 1;
        const fill = controls.querySelector('[data-progress-fill]');
        const previous = controls.querySelector('[data-direction="prev"]');
        const next = controls.querySelector('[data-direction="next"]');
        if (fill) fill.style.width = `${Math.min(100, Math.max(0, progress * 100))}%`;
        controls.classList.toggle('is-static', max < 2);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      updateCategoryControls() {
        if (!this.categoryTrack) return;
        const shell = this.categoryTrack.closest('[data-category-shell]');
        const categories = this.categoryTrack.querySelector('.bcp__categories');
        const availableWidth = shell && shell.parentElement ? shell.parentElement.clientWidth : this.categoryTrack.clientWidth;
        const isScrollable = categories ? categories.scrollWidth > availableWidth + 1 : false;
        if (shell) shell.classList.toggle('is-scrollable', isScrollable);
        const maximum = Math.max(0, this.categoryTrack.scrollWidth - this.categoryTrack.clientWidth);
        const previous = this.querySelector('[data-category-direction="prev"]');
        const next = this.querySelector('[data-category-direction="next"]');
        const progressFill = this.querySelector('[data-category-progress-fill]');
        const progress = maximum > 0
          ? (this.categoryTrack.scrollLeft + this.categoryTrack.clientWidth) / this.categoryTrack.scrollWidth
          : 0;
        if (progressFill) {
          progressFill.style.width = isScrollable
            ? `${Math.min(100, Math.max(0, progress * 100))}%`
            : '0%';
        }
        if (previous) {
          previous.hidden = !isScrollable;
          previous.disabled = this.categoryTrack.scrollLeft <= 2;
        }
        if (next) {
          next.hidden = !isScrollable;
          next.disabled = this.categoryTrack.scrollLeft >= maximum - 2;
        }
      }
    }

    customElements.define('collection-product-switcher', CollectionProductSwitcher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["betopper-flash-deals-v1"] && !Shopify.designMode) return;
  try {
    
(() => {
  const COMPONENT_NAME = 'betopper-flash-deals-v2';

  if (customElements.get(COMPONENT_NAME)) return;

  class BetopperFlashDeals extends HTMLElement {
    static lockCount = 0;
    static oldOverflow = '';
    connectedCallback() {
      if (document.readyState === 'loading') {
        this.readyHandler = () => this.initialize();
        document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
      } else {
        this.initialize();
      }
    }
    initialize() {
      if (!this.isConnected) return;
      if (this.controller) return;
      this.controller = new AbortController();
      this.selected = new Set();
      this.cards = new Map(Array.from(this.querySelectorAll('[data-key]'), card => [card.dataset.key, card]));
      this.hydrateSpecs();
      this.dialog = this.querySelector('dialog');
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => this.onClick(event), options);
      this.addEventListener('change', event => this.onChange(event), options);
      this.addEventListener('play', event => {
        if (event.target instanceof HTMLVideoElement) {
          document.querySelectorAll(`${COMPONENT_NAME} video`).forEach(video => {
            if (video !== event.target) video.pause();
          });
        }
      }, { ...options, capture: true });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || this.dialog?.open) return;
        const card = event.target.closest?.('.bfd__card.is-playing');
        if (card) {
          event.preventDefault();
          this.switchMedia(card.querySelector('[data-media="product"]'));
        }
      }, options);
      this.querySelectorAll('video').forEach(video => {
        video.setAttribute('aria-label', `${video.closest('[data-key]').dataset.title} light effects`);
        video.addEventListener('error', () => this.announce('Video could not load. Close the preview and try again.'), options);
      });
      this.initializeCarousel(options);
      this.initializeCountdown();
      this.querySelectorAll('[data-compare], [data-differences]').forEach(input => {
        input.checked = false;
      });
      if (this.dialog) {
        this.dialog.addEventListener('close', () => this.afterClose(), options);
        this.dialog.addEventListener('pointerdown', event => {
          this.backdropStart = event.target === this.dialog && this.outsideDialog(event);
        }, options);
        this.dialog.addEventListener('click', event => {
          if (this.backdropStart && event.target === this.dialog && this.outsideDialog(event)) this.dialog.close();
          this.backdropStart = false;
        }, options);
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseVideos();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) entry.target.pause();
        }), { threshold: 0.05 });
        this.querySelectorAll('video').forEach(video => this.observer.observe(video));
      }
      this.setAttribute('data-ready', '');
      this.syncSelection();
    }
    disconnectedCallback() {
      if (this.readyHandler) document.removeEventListener('DOMContentLoaded', this.readyHandler);
      this.pauseVideos();
      if (this.dialog?.open) this.dialog.close();
      this.releaseScroll();
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      clearInterval(this.countdownTimer);
      cancelAnimationFrame(this.carouselFrame);
    }
    initializeCountdown() {
      const raw = (this.dataset.endTime || '').trim();
      const wrap = this.querySelector('[data-countdown-wrap]');
      if (!wrap) return;
      const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!match) {
        if (raw) wrap.setAttribute('data-invalid-date', '');
        this.renderCountdown(0);
        return;
      }
      this.countdownEnd = Date.UTC(+match[1], +match[2] - 1, +match[3], +match[4] - 8, +match[5], +(match[6] || 0));
      const tick = () => {
        const remaining = Math.max(0, this.countdownEnd - Date.now());
        this.renderCountdown(remaining);
        if (remaining <= 0 && this.countdownTimer) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }

        return remaining;
      };

      if (tick() > 0) {
        this.countdownTimer = window.setInterval(tick, 1000);
      }
    }
    renderCountdown(ms) {
      const total = Math.floor(ms / 1000);
      const values = {
        days: Math.floor(total / 86400),
        hours: Math.floor(total / 3600) % 24,
        minutes: Math.floor(total / 60) % 60,
        seconds: total % 60
      };
      Object.entries(values).forEach(([key, value]) => {
        const node = this.querySelector(`[data-${key}]`);
        if (node) node.textContent = String(value).padStart(2, '0');
      });
    }
    hydrateSpecs() {
      this.cards.forEach(card => {
        const d = card.dataset;
        const title = d.productModel || d.productTitle;
        const category = d.categoryOverride || d.type;
        d.type = category;
        d.title = title;
        card.querySelector('.bfd__name a').textContent = title;
        const categoryNode = card.querySelector('[data-category]');
        if (categoryNode) {
          categoryNode.textContent = category;
          categoryNode.hidden = !category;
        }
        const input = card.querySelector('[data-compare]');
        if (input) input.setAttribute('aria-label', `Compare ${title}`);
        const template = card.querySelector('[data-comparison-header]');
        if (template) {
          template.content.querySelector('h3').textContent = title;
          const p = template.content.querySelector('[data-category]');
          if (p) {
            p.textContent = category;
            p.hidden = !category;
          }
          template.content.querySelector('[data-remove]').setAttribute('aria-label', `Remove ${title}`);
        }
      });
    }
    initializeCarousel(options) {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.slideCards = Array.from(this.track.children);
      const schedule = () => {
        cancelAnimationFrame(this.carouselFrame);
        this.carouselFrame = requestAnimationFrame(() => this.syncCarousel());
      };
      this.track.addEventListener('scroll', schedule, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goToSlide((this.activeSlide || 0) + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const card = this.slideCards.find(
          item => item.dataset.key === event.detail?.blockId || item.contains(event.target)
        );
        if (!card) return;
        this.measureCarousel();
        const index = this.slideCards.indexOf(card);
        this.goToSlide(this.cardPositions[index] || 0, true);
      }, options);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.measureCarousel());
        this.resizeObserver.observe(this.track);
      }
      window.addEventListener('resize', () => this.measureCarousel(), options);
      this.measureCarousel();
    }
    measureCarousel() {
      if (!this.track) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const firstLeft = this.slideCards[0]?.getBoundingClientRect().left || 0;
      const pageWidth = Math.max(1, this.track.clientWidth);
      const points = [0];
      for (let point = pageWidth; point < max - 3; point += pageWidth) {
        points.push(point);
      }
      if (max > 3 && Math.abs(points[points.length - 1] - max) > 3) points.push(max);
      this.slidePoints = points;
      this.cardPositions = this.slideCards.map(card => {
        const position = Math.min(max, Math.max(0, card.getBoundingClientRect().left - firstLeft));
        return points.reduce(
          (best, point, index) => Math.abs(point - position) < Math.abs(points[best] - position) ? index : best,
          0
        );
      });
      const dots = this.querySelector('[data-dots]');
      if (dots.children.length !== this.slidePoints.length) {
        dots.replaceChildren();
        this.slidePoints.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'bfd__dot';
          dot.dataset.slide = String(index);
          dot.setAttribute('aria-label', `Show product position ${index + 1}`);
          dot.setAttribute('aria-controls', this.track.id);
          dots.append(dot);
        });
      }
      this.querySelector('[data-carousel-nav]').hidden = max < 3;
      this.syncCarousel();
    }
    syncCarousel() {
      if (!this.slidePoints?.length) return;
      const current = Math.max(0, this.track.scrollLeft);
      this.activeSlide = this.slidePoints.reduce(
        (best, point, index) => Math.abs(point - current) < Math.abs(this.slidePoints[best] - current) ? index : best,
        0
      );
      this.querySelectorAll('[data-slide]').forEach((dot, index) => {
        dot.setAttribute('aria-current', String(index === this.activeSlide));
      });
      this.querySelector('[data-prev]').disabled = this.activeSlide === 0;
      this.querySelector('[data-next]').disabled = this.activeSlide === this.slidePoints.length - 1;
    }
    goToSlide(index, instant = false) {
      if (!this.slidePoints?.length) return;
      const bounded = Math.max(0, Math.min(index, this.slidePoints.length - 1));
      const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.slidePoints[bounded], behavior: instant || reduced ? 'auto' : 'smooth' });
    }
    outsideDialog(event) {
      const r = this.dialog.getBoundingClientRect();
      return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
    }
    announce(text) {
      const status = this.querySelector('[data-status]');
      if (status) status.textContent = text;
    }
    pauseVideos(except) {
      this.querySelectorAll('video').forEach(video => {
        if (video !== except) video.pause();
      });
    }
    onClick(event) {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-prev')) this.goToSlide((this.activeSlide || 0) - 1);
      if (button.hasAttribute('data-next')) this.goToSlide((this.activeSlide || 0) + 1);
      if (button.hasAttribute('data-slide')) this.goToSlide(Number(button.dataset.slide));
      if (button.hasAttribute('data-media')) this.switchMedia(button);
      if (button.hasAttribute('data-clear')) {
        this.selected.clear();
        this.syncSelection();
        this.announce('Selection cleared.');

        if (this.dialog?.open) {
          this.returnFocus = this.querySelector('[data-compare]');
          this.dialog.close();
        }

        this.querySelector('[data-compare]')?.focus();
      }
      if (button.hasAttribute('data-remove')) {
        const wasOpen = this.dialog?.open;
        const removedIndex = Array.from(this.selected).indexOf(button.dataset.remove);
        this.selected.delete(button.dataset.remove);
        this.syncSelection();

        if (wasOpen && this.selected.size >= 2) {
          const scroller = this.querySelector('.bfd__table-scroll');
          const left = scroller.scrollLeft;
          this.buildComparison();
          scroller.scrollLeft = left;
          const remaining = this.querySelectorAll('[data-table-head] [data-remove]');
          remaining[Math.min(Math.max(0, removedIndex), remaining.length - 1)]?.focus({ preventScroll:true });
        } else if (wasOpen) {
          this.returnFocus = this.querySelector('[data-compare]');
          this.dialog.close();
        } else {
          this.querySelector('[data-compare]')?.focus();
        }

        const message = this.selected.size >= 2
          ? `Product removed. ${this.selected.size} products selected.`
          : 'Product removed. Select another product to compare.';
        this.announce(message);
      }
      if (button.hasAttribute('data-open')) this.openComparison(button);
      if (button.hasAttribute('data-close')) this.dialog.close();
    }
    onChange(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (input.hasAttribute('data-compare')) {
        const key = input.closest('[data-key]').dataset.key;
        if (input.checked && this.selected.size >= 8 && !this.selected.has(key)) {
          input.checked = false;
          this.announce('Compare up to 8 products. Remove one before adding another.');
          return;
        }
        if (input.checked) {
          this.selected.add(key);
        } else {
          this.selected.delete(key);
        }

        this.syncSelection();

        let message = 'Selection cleared.';
        if (this.selected.size === 1) {
          message = 'Select one more product to compare.';
        } else if (this.selected.size >= 2) {
          message = `${this.selected.size} products selected. Compare now is ready.`;
        }
        this.announce(message);
      }
      if (input.hasAttribute('data-differences')) this.filterDifferences();
    }
    switchMedia(button) {
      const card = button.closest('[data-key]');
      const effects = button.dataset.media === 'effects';
      const panel = card.querySelector('[data-video]');
      if (!panel) return;
      card.querySelector('[data-photo]').hidden = effects;
      panel.hidden = !effects;
      card.classList.toggle('is-playing', effects);
      const watch = card.querySelector('[data-media="effects"]');
      const close = card.querySelector('[data-media="product"]');
      watch.hidden = effects;
      watch.setAttribute('aria-expanded', String(effects));
      close.hidden = !effects;
      (effects ? close : watch).focus({ preventScroll:true });
      const video = panel.querySelector('video');
      if (!video) return;
      if (effects) {
        this.pauseVideos(video);
        video.muted = true;
        const play = video.play();
        if (play?.catch) play.catch(() => {
          if (!panel.hidden) this.announce('Use the video play button to start the preview.');
        });
      } else {
        video.pause();
      }
    }
    syncSelection() {
      this.cards.forEach((card, key) => {
        const selected = this.selected.has(key);
        card.classList.toggle('is-selected', selected);
        const checkbox = card.querySelector('[data-compare]');
        if (checkbox) checkbox.checked = selected;
      });
      const tray = this.querySelector('[data-tray]');
      if (!tray) return;
      tray.hidden = this.selected.size === 0;
      this.querySelector('[data-count]').textContent = `${this.selected.size} selected · Max 8`;
      const open = this.querySelector('[data-open]');
      open.disabled = this.selected.size < 2;
      open.textContent = `COMPARE (${this.selected.size})`;
      const chips = this.querySelector('[data-chips]');
      chips.replaceChildren();
      this.selected.forEach(key => {
        const card = this.cards.get(key);
        const chip = document.createElement('div');
        chip.className = 'bfd__chip';
        const original = card.querySelector('[data-photo] img');

        if (original) {
          const img = document.createElement('img');
          img.src = original.currentSrc || original.src;
          img.alt = '';
          img.width = 34;
          img.height = 34;
          chip.append(img);
        }

        const name = document.createElement('span');
        name.textContent = card.dataset.title;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.dataset.remove = key;
        remove.setAttribute('aria-label', `Remove ${card.dataset.title}`);
        remove.textContent = '×';
        chip.append(name, remove);
        chips.append(chip);
      });
    }
    openComparison(trigger) {
      if (this.selected.size < 2 || this.selected.size > 8 || !this.dialog || this.dialog.open) return;
      this.buildComparison();
      this.pauseVideos();
      this.returnFocus = trigger;
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
      this.querySelector('.bfd__table-scroll').scrollLeft = 0;
      this.querySelector('[data-close]').focus({ preventScroll: true });
      if (!this.scrollLocked) {
        if (BetopperFlashDeals.lockCount === 0) {
          BetopperFlashDeals.oldOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
        }
        BetopperFlashDeals.lockCount += 1;
        this.scrollLocked = true;
      }
    }
    releaseScroll() {
      if (!this.scrollLocked) return;
      BetopperFlashDeals.lockCount = Math.max(0, BetopperFlashDeals.lockCount - 1);
      if (BetopperFlashDeals.lockCount === 0) document.documentElement.style.overflow = BetopperFlashDeals.oldOverflow;
      this.scrollLocked = false;
    }
    afterClose() {
      this.releaseScroll();
      if (this.isConnected && this.returnFocus?.isConnected && !this.returnFocus.disabled) this.returnFocus.focus({ preventScroll: true });
    }
    buildComparison() {
      const cards = Array.from(this.selected, key => this.cards.get(key));
      this.querySelector('[data-dialog-count]').textContent = `${cards.length} selected · Max 8`;
      const table = this.querySelector('.bfd__table');
      table.style.setProperty('--bfd-table-min', `${160 + cards.length * 220}px`);
      table.style.setProperty('--bfd-table-mobile-min', `${96 + cards.length * 148}px`);
      const cols = this.querySelector('[data-table-cols]');
      cols.replaceChildren();
      const labelCol = document.createElement('col');
      labelCol.className = 'bfd__label-col';
      cols.append(labelCol);
      cards.forEach(() => cols.append(document.createElement('col')));
      const head = this.querySelector('[data-table-head]');
      const body = this.querySelector('[data-table-body]');
      const foot = this.querySelector('[data-table-foot]');
      head.replaceChildren();
      body.replaceChildren();
      foot.replaceChildren();
      const top = document.createElement('tr');
      const lead = document.createElement('th');
      lead.scope = 'col';
      lead.textContent = 'Compare features';
      top.append(lead);

      cards.forEach(card => {
        const th = document.createElement('th');
        th.scope = 'col';
        th.append(card.querySelector('[data-comparison-header]').content.cloneNode(true));
        top.append(th);
      });
      head.append(top);
      const fields = [
        ['type', 'Product description'],
        ['source', 'Light source'],
        ['beam', 'Beam / zoom'],
        ['color', 'Color system'],
        ['effects', 'Main effects'],
        ['focus', 'Focus'],
        ['channels', 'DMX modes'],
        ['weight', 'Net weight'],
        ['ip', 'Protection']
      ];

      fields.forEach(([key, label]) => {
        const values = cards.map(card => (card.dataset[key] || '').trim());
        if (values.every(value => !value)) return;
        const normalized = values.map(value => value.replace(/\s+/g, ' ').toLowerCase());
        const different = new Set(normalized).size > 1;
        const row = document.createElement('tr');
        row.dataset.different = String(different);
        row.classList.toggle('is-different', different);
        const th = document.createElement('th');
        th.scope = 'row';
        th.textContent = label;
        row.append(th);
        values.forEach(value => {
          const td = document.createElement('td');
          if (key === 'effects') td.classList.add('bfd__cell--multiline');
          td.textContent = value || 'Not provided';
          row.append(td);
        });
        body.append(row);
      });

      const priceRow = document.createElement('tr');
      const priceLabel = document.createElement('th');
      priceLabel.scope = 'row';
      priceLabel.textContent = 'Current price';
      priceRow.append(priceLabel);
      cards.forEach(card => {
        const td = document.createElement('td');
        td.append(card.querySelector('[data-pricing]').cloneNode(true));
        priceRow.append(td);
      });

      const actionRow = document.createElement('tr');
      const actionLabel = document.createElement('th');
      actionLabel.scope = 'row';
      const actionText = document.createElement('span');
      actionText.className = 'bfd__sr';
      actionText.textContent = 'Shop product';
      actionLabel.append(actionText);
      actionRow.append(actionLabel);

      cards.forEach(card => {
        const td = document.createElement('td');
        td.append(card.querySelector('[data-purchase]').cloneNode(true));
        const details = document.createElement('a');
        details.href = card.querySelector('.bfd__name a').href;
        details.className = 'bfd__details';
        details.textContent = 'View full details';
        td.append(details);
        actionRow.append(td);
      });
      foot.append(priceRow, actionRow);
      this.filterDifferences();
    }
    filterDifferences() {
      const only = this.querySelector('[data-differences]').checked;
      let visible = 0;
      this.querySelectorAll('[data-table-body] tr').forEach(row => {
        row.hidden = only && row.dataset.different !== 'true';
        if (!row.hidden) visible += 1;
      });
      const message = this.querySelector('[data-no-differences]');
      message.hidden = visible > 0;
      message.textContent = only
        ? 'No differing specifications are available for these products.'
        : 'Specifications have not been added for these products yet.';
    }
  }

  customElements.define(COMPONENT_NAME, BetopperFlashDeals);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["betopper-sale-nav-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sale-collection-showcase-v5')) {
    customElements.define('sale-collection-showcase-v5', class extends HTMLElement {
      connectedCallback() {
        this.hydrateCollections();
        this.modeButtons = Array.from(this.querySelectorAll('[data-mode-button]'));
        this.tabGroups = Array.from(this.querySelectorAll('[data-tab-group]'));
        this.collectionButtons = Array.from(this.querySelectorAll('[data-collection-button]'));
        this.panels = Array.from(this.querySelectorAll('[data-collection-panel]'));
        this.navArrows = Array.from(this.querySelectorAll('[data-nav-direction]'));
        this.liveStatus = this.querySelector('[data-live-status]');
        this.dialog = this.querySelector('[data-variant-dialog]');
        this.dialogOptions = this.querySelector('[data-variant-options]');
        this.dialogTitle = this.querySelector('[data-variant-title]');
        this.dialogImage = this.querySelector('[data-variant-image]');
        this.dialogPrice = this.querySelector('[data-variant-price]');
        this.dialogCompare = this.querySelector('[data-variant-compare]');
        this.dialogMessage = this.querySelector('[data-variant-message]');
        this.dialogSubmit = this.querySelector('[data-variant-submit]');
        this.pendingScrollerUpdates = new WeakSet();

        this.collectionButtons.forEach((button) => {
          button.addEventListener('click', () => this.activateCollection(button));
          button.addEventListener('keydown', (event) => this.onTabKeydown(event, button));
        });

        this.navArrows.forEach((button) => {
          button.addEventListener('click', () => this.scrollNavigation(button));
        });

        this.tabGroups.forEach((group) => {
          group.addEventListener('scroll', () => this.updateNavControls(), { passive: true });
        });

        this.querySelectorAll('[data-scroll-direction]').forEach((button) => {
          button.addEventListener('click', () => this.scrollProducts(button));
        });

        this.querySelectorAll('[data-product-scroller]').forEach((scroller) => {
          scroller.addEventListener('scroll', () => this.scheduleScrollerUpdate(scroller), { passive: true });
        });

        this.querySelectorAll('[data-quick-add-form]').forEach((form) => {
          form.addEventListener('submit', (event) => this.quickAdd(event, form));
        });

        this.querySelectorAll('[data-variant-trigger]').forEach((button) => {
          button.addEventListener('click', () => this.openVariantPicker(button));
        });

        if (this.dialog) {
          this.querySelector('[data-variant-close]').addEventListener('click', () => this.closeVariantPicker());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.closeVariantPicker();
          });
          this.dialogSubmit.addEventListener('click', () => this.addSelectedVariant());
        }

        this.onBlockSelect = (event) => {
          const source = event.target.closest('[data-collection-source]') || event.target.querySelector('[data-collection-source]');
          const panel = source ? source.querySelector('[data-panel-source]') : null;
          if (!panel || !this.contains(panel)) return;
          const key = panel.dataset.collectionPanel;
          const button = this.querySelector(`[data-collection-button="${CSS.escape(key)}"]`);
          if (button) this.activateCollection(button);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver = new ResizeObserver((entries) => {
          const nextWidth = Math.round(entries[0].contentRect.width);
          if (nextWidth === this.observedWidth) return;
          this.observedWidth = nextWidth;
          if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            const activePanel = this.panels.find((panel) => !panel.hidden);
            if (activePanel) {
              this.fitProductPanel(activePanel);
              const scroller = activePanel.querySelector('[data-product-scroller]');
              if (scroller) this.scheduleScrollerUpdate(scroller);
            }
            this.updateNavControls();
          });
        });
        const productGroup = this.querySelector('[data-tab-group="product"]');
        const initialButton = productGroup ? productGroup.querySelector('[data-collection-button]') : null;
        const discovery = this.querySelector('[data-discovery]');
        const emptyState = this.querySelector('[data-editor-empty]');
        if (initialButton) {
          this.prepareInitialPanel(initialButton.dataset.collectionButton);
          if (discovery) discovery.hidden = false;
          if (emptyState) emptyState.hidden = true;
          this.activateCollection(initialButton);
          requestAnimationFrame(() => this.updateNavControls());
        } else {
          if (discovery) discovery.hidden = true;
          if (emptyState) emptyState.hidden = false;
        }
        this.resizeObserver.observe(this);
      }

      hydrateCollections() {
        const modeSources = Array.from(this.querySelectorAll('[data-mode-source="product"]'));
        const modeSwitch = this.querySelector('.bsc__mode-switch');
        modeSources.forEach((modeSource) => {
          const mode = modeSource.dataset.modeSource;
          const modeButton = this.querySelector(`[data-mode-button="${mode}"]`);
          if (modeSwitch && modeButton) modeSwitch.appendChild(modeButton);
          const tabGroup = this.querySelector(`[data-tab-group="${mode}"]`);
          if (!tabGroup) return;
          modeSource.querySelectorAll('[data-collection-source]').forEach((source) => {
            const template = source.querySelector('[data-collection-nav-template]');
            const panel = source.querySelector('[data-panel-source]');
            if (!template || !panel) return;
            const button = template.content.firstElementChild.cloneNode(true);
            const key = `${mode}-${source.dataset.blockKey}`;
            button.dataset.collectionButton = key;
            button.tabIndex = -1;
            panel.dataset.collectionPanel = key;
            panel.dataset.navigationMode = mode;
            tabGroup.appendChild(button);
          });
        });
      }

      prepareInitialPanel(handle) {
        this.panels.forEach((panel) => {
          const active = panel.dataset.collectionPanel === handle;
          panel.hidden = !active;
          panel.querySelectorAll('img').forEach((image, index) => {
            image.decoding = 'async';
            if (!active || index > 7) {
              image.loading = 'lazy';
              image.fetchPriority = 'low';
            } else {
              image.loading = 'eager';
              image.fetchPriority = index === 0 ? 'high' : 'auto';
            }
          });
        });
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      }

      activateMode(mode) {
        this.modeButtons.forEach((button) => {
          const active = button.dataset.modeButton === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.tabGroups.forEach((group) => {
          group.hidden = group.dataset.tabGroup !== mode;
        });

        const activeGroup = this.querySelector(`[data-tab-group="${mode}"]`);
        if (!activeGroup) return;
        const selected = activeGroup.querySelector('.is-active') || activeGroup.querySelector('[data-collection-button]');
        if (selected) this.activateCollection(selected);
        requestAnimationFrame(() => this.updateNavControls());
      }

      scrollNavigation(button) {
        const activeGroup = this.tabGroups.find((group) => !group.hidden);
        if (!activeGroup) return;
        const direction = button.dataset.navDirection === 'next' ? 1 : -1;
        activeGroup.scrollLeft += activeGroup.clientWidth * .72 * direction;
        this.updateNavControls();
      }

      updateNavControls() {
        const activeGroup = this.tabGroups.find((group) => !group.hidden);
        if (!activeGroup) return;
        const maximum = Math.max(0, activeGroup.scrollWidth - activeGroup.clientWidth);
        const navigationFits = maximum <= 2;
        activeGroup.classList.toggle('is-centered', navigationFits);
        const navigationGroups = activeGroup.closest('.bsc__collection-groups');
        if (navigationGroups) navigationGroups.classList.toggle('is-navigation-fitted', navigationFits);
        this.navArrows.forEach((button) => {
          button.hidden = navigationFits;
          if (button.dataset.navDirection === 'prev') {
            button.disabled = activeGroup.scrollLeft <= 2;
          } else {
            button.disabled = activeGroup.scrollLeft >= maximum - 2;
          }
        });
      }

      activateCollection(button) {
        const handle = button.dataset.collectionButton;
        const group = button.closest('[data-tab-group]');

        if (group) {
          group.querySelectorAll('[data-collection-button]').forEach((tab) => {
            const active = tab === button;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
        }

        const changePanel = () => {
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.collectionPanel !== handle;
          });
          const activePanel = this.querySelector(`[data-collection-panel="${CSS.escape(handle)}"]`);
          const scroller = activePanel ? activePanel.querySelector('[data-product-scroller]') : null;
          if (scroller) {
            this.fitProductPanel(activePanel);
            scroller.scrollLeft = 0;
            this.updateProgress(scroller);
            this.updateProductControls(scroller);
          }
        };

        changePanel();
      }

      fitProductPanel(panel) {
        if (!panel) return;
        const scroller = panel.querySelector('[data-product-scroller]');
        if (!scroller) return;
        const cards = Array.from(scroller.querySelectorAll('[data-product-card]'));
        const desktop = window.matchMedia('(min-width: 990px)').matches;
        const columns = Math.max(1, Number.parseInt(getComputedStyle(this).getPropertyValue('--bsc-desktop-columns'), 10) || 6);
        const fitKey = `${desktop ? 'desktop' : 'compact'}-${Math.round(this.getBoundingClientRect().width)}-${cards.length}-${columns}`;
        if (panel.dataset.fitKey === fitKey) return;
        panel.dataset.fitKey = fitKey;
        if (!desktop) {
          panel.style.removeProperty('width');
          scroller.style.removeProperty('grid-auto-columns');
          return;
        }
        panel.style.width = '100%';
        scroller.style.removeProperty('grid-auto-columns');
        if (!cards.length) return;
        const visibleCards = Math.min(cards.length, columns);
        const cardWidth = cards[0].getBoundingClientRect().width;
        const scrollerStyles = getComputedStyle(scroller);
        const gap = Number.parseFloat(scrollerStyles.columnGap) || 0;
        const panelStyles = getComputedStyle(panel);
        const frameWidth = ['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth']
          .reduce((total, property) => total + (Number.parseFloat(panelStyles[property]) || 0), 0);
        scroller.style.gridAutoColumns = `${cardWidth}px`;
        panel.style.width = `${Math.ceil(frameWidth + (cardWidth * visibleCards) + (gap * Math.max(0, visibleCards - 1)))}px`;
      }

      onTabKeydown(event, button) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const tabs = Array.from(button.closest('[data-tab-group]').querySelectorAll('[data-collection-button]'));
        const current = tabs.indexOf(button);
        let next = current;
        if (event.key === 'ArrowLeft') next = current === 0 ? tabs.length - 1 : current - 1;
        if (event.key === 'ArrowRight') next = current === tabs.length - 1 ? 0 : current + 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        event.preventDefault();
        tabs[next].focus();
        tabs[next].click();
      }

      scrollProducts(button) {
        const panel = button.closest('[data-collection-panel]');
        const scroller = panel.querySelector('[data-product-scroller]');
        const card = scroller.querySelector('[data-product-card]');
        if (!card) return;
        const direction = button.dataset.scrollDirection === 'next' ? 1 : -1;
        const gap = Number.parseFloat(getComputedStyle(scroller).columnGap) || 0;
        scroller.scrollLeft += (card.getBoundingClientRect().width + gap) * direction;
        this.scheduleScrollerUpdate(scroller);
      }

      scheduleScrollerUpdate(scroller) {
        if (!scroller || this.pendingScrollerUpdates.has(scroller)) return;
        this.pendingScrollerUpdates.add(scroller);
        requestAnimationFrame(() => {
          this.pendingScrollerUpdates.delete(scroller);
          if (!scroller.isConnected) return;
          this.updateProgress(scroller);
          this.updateProductControls(scroller);
        });
      }

      updateProgress(scroller) {
        const panel = scroller.closest('[data-collection-panel]');
        const bar = panel.querySelector('[data-progress-bar]');
        if (!bar) return;
        const maximum = scroller.scrollWidth - scroller.clientWidth;
        const visibleRatio = Math.min(1, scroller.clientWidth / scroller.scrollWidth);
        const travel = 1 - visibleRatio;
        const position = maximum > 0 ? scroller.scrollLeft / maximum : 0;
        bar.style.width = `${visibleRatio * 100}%`;
        bar.style.transform = `translateX(${travel > 0 ? position * travel / visibleRatio * 100 : 0}%)`;
      }

      updateProductControls(scroller) {
        const panel = scroller.closest('[data-collection-panel]');
        if (!panel) return;
        const maximum = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const previous = panel.querySelector('[data-scroll-direction="prev"]');
        const next = panel.querySelector('[data-scroll-direction="next"]');
        if (previous) previous.disabled = maximum <= 2 || scroller.scrollLeft <= 2;
        if (next) next.disabled = maximum <= 2 || scroller.scrollLeft >= maximum - 2;
      }

      async quickAdd(event, form) {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');

        try {
          const item = await this.addItem(new FormData(form));
          button.classList.add('is-added');
          if (this.liveStatus) this.liveStatus.textContent = `${item.product_title || item.title} ${this.dataset.addedLabel}`;
          window.setTimeout(() => button.classList.remove('is-added'), 1600);
        } catch (error) {
          if (this.liveStatus) this.liveStatus.textContent = this.dataset.errorLabel;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      openVariantPicker(trigger) {
        const card = trigger.closest('[data-product-card]');
        const productData = card ? card.querySelector('[data-product-json]') : null;
        if (!productData || !this.dialog) return;
        try {
          this.variantProduct = JSON.parse(productData.textContent);
        } catch (error) {
          return;
        }
        this.variantTrigger = trigger;
        this.variantOptionNames = (this.variantProduct.options || []).map((option) => typeof option === 'string' ? option : option.name);
        const availableVariants = (this.variantProduct.variants || []).filter((variant) => variant.available);
        if (!availableVariants.length) return;

        const plugIndex = this.variantOptionNames.findIndex((name) => String(name).trim().toLowerCase() === 'plug');
        const preferredPlug = this.preferredPlugValue();
        const plugValues = plugIndex >= 0 ? [...new Set(availableVariants.map((variant) => variant.options[plugIndex]))] : [];
        const matchedPlug = preferredPlug ? plugValues.find((value) => this.normalizePlug(value) === preferredPlug) : null;
        let candidates = availableVariants;
        if (matchedPlug) candidates = availableVariants.filter((variant) => variant.options[plugIndex] === matchedPlug);
        const seed = candidates.reduce((lowest, variant) => Number(variant.price) < Number(lowest.price) ? variant : lowest, candidates[0]);
        this.variantSelections = [...seed.options];
        if (plugIndex >= 0) this.variantSelections[plugIndex] = matchedPlug || null;
        this.dialogTitle.textContent = this.variantProduct.title;
        this.renderVariantOptions();
        this.updateSelectedVariant();
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
      }

      preferredPlugValue() {
        const country = String(this.dataset.countryCode || '').toUpperCase();
        if (['US', 'CA'].includes(country)) return 'usca';
        if (country === 'GB') return 'uk';
        if (country === 'JP') return 'jp';
        if (['AU', 'NZ'].includes(country)) return 'au';
        const euCountries = ['AT', 'BE', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LI', 'LT', 'LU', 'LV', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
        return euCountries.includes(country) ? 'eu' : null;
      }

      normalizePlug(value) {
        return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      }

      renderVariantOptions() {
        this.dialogOptions.innerHTML = '';
        this.variantOptionNames.forEach((name, optionIndex) => {
          const fieldset = document.createElement('fieldset');
          fieldset.className = 'bsc__variant-fieldset';
          const legend = document.createElement('legend');
          legend.textContent = name;
          fieldset.appendChild(legend);
          const valuesWrap = document.createElement('div');
          valuesWrap.className = 'bsc__variant-values';
          const values = [...new Set(this.variantProduct.variants.map((variant) => variant.options[optionIndex]))];
          values.forEach((value) => {
            const valueButton = document.createElement('button');
            valueButton.type = 'button';
            valueButton.className = 'bsc__variant-value';
            valueButton.textContent = value;
            valueButton.dataset.optionIndex = String(optionIndex);
            valueButton.dataset.optionValue = value;
            valueButton.addEventListener('click', () => {
              this.variantSelections[optionIndex] = value;
              this.renderVariantOptions();
              this.updateSelectedVariant();
            });
            valuesWrap.appendChild(valueButton);
          });
          fieldset.appendChild(valuesWrap);
          this.dialogOptions.appendChild(fieldset);
        });
        this.dialogOptions.querySelectorAll('[data-option-index]').forEach((button) => {
          const index = Number(button.dataset.optionIndex);
          const value = button.dataset.optionValue;
          const selected = this.variantSelections[index] === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          button.disabled = !this.variantProduct.variants.some((variant) => {
            if (!variant.available || variant.options[index] !== value) return false;
            return variant.options.every((optionValue, otherIndex) => otherIndex === index || this.variantSelections[otherIndex] == null || this.variantSelections[otherIndex] === optionValue);
          });
        });
      }

      updateSelectedVariant() {
        const complete = this.variantSelections.every((value) => value != null);
        this.selectedVariant = complete ? this.variantProduct.variants.find((variant) => variant.available && variant.options.every((value, index) => value === this.variantSelections[index])) : null;
        const displayVariant = this.selectedVariant || this.variantProduct.variants.filter((variant) => variant.available).sort((a, b) => Number(a.price) - Number(b.price))[0];
        const image = displayVariant && displayVariant.featured_image ? displayVariant.featured_image : this.variantProduct.featured_image;
        if (image) {
          this.dialogImage.src = String(typeof image === 'string' ? image : image.src).replace(/^\/\//, 'https://');
          this.dialogImage.hidden = false;
        } else {
          this.dialogImage.hidden = true;
        }
        this.dialogImage.alt = this.variantProduct.title;
        this.dialogPrice.textContent = this.formatMoney(displayVariant.price);
        const comparePrice = Number(displayVariant.compare_at_price || 0);
        this.dialogCompare.hidden = comparePrice <= Number(displayVariant.price);
        this.dialogCompare.textContent = comparePrice > Number(displayVariant.price) ? this.formatMoney(comparePrice) : '';
        const available = Boolean(this.selectedVariant && this.selectedVariant.available);
        this.dialogSubmit.disabled = !available;
        const selectionText = this.variantSelections.filter(Boolean).join(' / ');
        const addLabel = this.dataset.addLabel || 'ADD TO CART';
        const unavailableLabel = this.dataset.unavailableLabel || 'CHOOSE AN AVAILABLE COMBINATION';
        this.dialogMessage.textContent = available ? '' : unavailableLabel;
        this.dialogSubmit.textContent = available ? `${addLabel} — ${selectionText}` : unavailableLabel;
      }

      formatMoney(cents) {
        const currency = this.dataset.currencyCode || 'USD';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents || 0) / 100);
        } catch (error) {
          return `${currency} ${(Number(cents || 0) / 100).toFixed(2)}`;
        }
      }

      async addSelectedVariant() {
        if (!this.selectedVariant || !this.selectedVariant.available || this.dialogSubmit.disabled) return;
        this.dialogSubmit.disabled = true;
        this.dialogSubmit.setAttribute('aria-busy', 'true');
        try {
          const item = await this.addItem({ items: [{ id: this.selectedVariant.id, quantity: 1 }] });
          if (this.variantTrigger) {
            this.variantTrigger.classList.add('is-added');
            window.setTimeout(() => this.variantTrigger.classList.remove('is-added'), 1600);
          }
          if (this.liveStatus) this.liveStatus.textContent = `${item.product_title || item.title} ${this.dataset.addedLabel}`;
          this.closeVariantPicker();
        } catch (error) {
          this.dialogMessage.textContent = this.dataset.errorLabel || 'Unable to add this item. Please try again.';
          this.dialogSubmit.disabled = false;
        } finally {
          this.dialogSubmit.removeAttribute('aria-busy');
        }
      }

      async addItem(body) {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const isFormData = body instanceof FormData;
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: isFormData ? { Accept: 'application/json' } : { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: isFormData ? body : JSON.stringify(body)
        });
        if (!response.ok) throw new Error('Cart request failed');
        const result = await response.json();
        const item = result.items ? result.items[0] : result;
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item, cart: result } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { item, cart: result } }));
        return item;
      }

      closeVariantPicker() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
        else this.dialog.removeAttribute('open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tuwenlunbo"] && !Shopify.designMode) return;
  try {
    
  {{ 'feature-carousel.js' | asset_url | script_tag }}

  } catch(e) { console.error(e); }
})();
})();
